<template>
  <div>
    <v-container class="container-full">
      <v-row
        no-gutters
        class="text-center dark"
        align="center"
        justify="center"
      >
        <v-col cols="12" sm="7">
          <v-img src="../assets/home-cropped.jpg" align></v-img>
        </v-col>
        <v-col cols="12" sm="5" class="cta">
          <p>
            Get full transparency on how your donation contribution is being used.
          </p>

          <p>
            Choose where you make an impact.
          </p>

          <v-btn to="/subscribe" color="secondary" raised="true">
            Donate now
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="container-full primary information">
      <v-row>
        <v-col cols="12" class="text-center">
          <h2>What is DoleFund?</h2>

          <p>
            DoleFund is a donation platform for individuals that want to make a non-monetary donation.
          </p>

          <p>
            Find non-profits and charities on our platform and purchase and send them supplies directly.
          </p>

          <v-btn to="/about" color="secondary" raised="true">
            Learn More
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<style scoped>
.cta {
  padding: 2rem;
}

.dark {
  color: #fff;
}

.primary {
  color: #fff;
}

.information {
  padding: 3rem 1rem;
}

h2 {
  margin-bottom: 2rem;
}
</style>